import { postAPICall } from "../helpers/httpHelper";
import { db } from "../utils/db";

import {
  paginationHelper,
  getPaginationResponse,
} from "../utils/paginationHelper";

import store from "@/store";

//delete entity by id
export const deleteEntityView = async (entityViewId) => {
  let appUsingMode = store.getters["auth/getAppMode"];
  if(!appUsingMode){
    return
  }
  const [selectedEntityView] = await db.entity_view_configuration
    .where("_id")
    .equals(entityViewId)
    .primaryKeys();
  if (selectedEntityView) {
    await db.entity_view_configuration.delete(selectedEntityView);
  }
};

//update single entity
export const updateEntityViewData = async (entityViewId, data) => {
  let appUsingMode = store.getters["auth/getAppMode"];
  if(!appUsingMode){
    return
  }
  if (data?.id) {
    delete data.id;
  }
  const selectedEntityView = await fetchDataCustomdashboardIdFromLocal(
    entityViewId
  );
  if (selectedEntityView) {
    await db.entity_view_configuration.delete(selectedEntityView);
    await addSingleEntityViewToLocal(data);
  } else {
    await addSingleEntityViewToLocal(data);
  }
};

export const fetchDataCustomdashboardIdFromLocal = async (id) => {
  const [selectedEntityCustomization] = await db.entity_view_configuration
    .where("_id")
    .equals(id)
    .primaryKeys();
  return selectedEntityCustomization;
};

export const addSingleEntityViewToLocal = async (viewData) => {
  let appUsingMode = store.getters["auth/getAppMode"];
  if(!appUsingMode){
    return
  }
  return db.entity_view_configuration.add({
    ...viewData,
    ...{ createdAt: new Date().toISOString() },
  });
};

export const fetchEntityViews = async (params) => {
  let entityViews;
  entityViews = await fetchEntityViewsFromLocal(params);
  if (!entityViews) {
    entityViews = await fetchEntityViewsFromDatabase(params);
  }
  return entityViews;
};

export const fetchEntityViewsFromLocal = async (params) => {
  let collection = db.entity_view_configuration;
  if (params.order_by) {
    collection = collection.orderBy(params.order_by);
    if (params.order_type === "desc") {
      collection = collection.reverse();
    }
  } else {
    collection = collection.orderBy("updated_at");
    collection = collection.reverse();
  }
  const regex = new RegExp(params.search_string || "", "i");
  if (params?.search_string) {
    collection = collection.filter((view) => {
      return regex.test(view.name);
    });
  }

  const count = await collection.count();
  if (params.limit) {
    params.skip = (params.page - 1) * params.limit;
  }
  collection = paginationHelper(collection, params);
  const results = await collection.toArray();
  if (!results || !results.length) {
    return null;
  }
  return getPaginationResponse({
    page: params.page || 1,
    count,
    limit: params.limit || 10,
    skip: params.skip,
    data: results,
    data_field: "data",
    message: "Entity views fetched successfully.",
  });
};
export const fetchEntityViewsFromDatabase = async (params) => {
  return postAPICall("GET", `/entity-view-configuration`, params);
};
